import { styled } from '@material-ui/core';

export const Container = styled('div')({});
